import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Language = 'th' | 'en';

interface LanguageStore {
  language: Language;
  hasUserSetLanguage: boolean;
  setLanguage: (language: Language) => void;
  setLanguageFromSystem: (language: Language) => void;
  clearUserLanguageFlag: () => void;
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set, get) => ({
      language: 'th',
      hasUserSetLanguage: false,
      setLanguage: (language) => set({ language, hasUserSetLanguage: true }),
      setLanguageFromSystem: (language) => {
         set({ language });
      },
      clearUserLanguageFlag: () => set({ hasUserSetLanguage: false }),
    }),
    {
      name: 'language-store',
    }
  )
);